import {
  resolveAfterGuideTourPostScrollReveal,
  runAfterGuideTourLayoutFrames,
} from './animationFrames'
import { isGuideTourPageScrollLocked } from './scrollLock'
import {
  GUIDE_TOUR_POST_SCROLL_REVEAL_MS,
  GUIDE_TOUR_SMOOTH_SCROLL_FALLBACK_MS,
} from './overlayTiming'

const createSettlePromise = (): {
  promise: Promise<void>
  resolve: () => void
} => {
  let settle!: () => void
  const promise = new Promise<void>(resolve => {
    settle = resolve
  })

  return { promise, resolve: settle }
}

const settleAfterLockedPageScroll = (): Promise<void> => {
  const { promise, resolve } = createSettlePromise()

  runAfterGuideTourLayoutFrames(() => {
    resolveAfterGuideTourPostScrollReveal(
      resolve,
      GUIDE_TOUR_POST_SCROLL_REVEAL_MS
    )
  })

  return promise
}

const settleAfterWindowScroll = (): Promise<void> => {
  const { promise, resolve } = createSettlePromise()
  let settled = false

  const finish = () => {
    if (settled) {
      return
    }

    settled = true
    window.clearTimeout(fallbackTimer)
    window.removeEventListener('scrollend', onScrollEnd, true)
    resolveAfterGuideTourPostScrollReveal(
      resolve,
      GUIDE_TOUR_POST_SCROLL_REVEAL_MS
    )
  }

  const onScrollEnd = () => {
    finish()
  }

  const fallbackTimer = window.setTimeout(
    finish,
    GUIDE_TOUR_SMOOTH_SCROLL_FALLBACK_MS
  )

  if ('onscrollend' in window) {
    window.addEventListener('scrollend', onScrollEnd, {
      capture: true,
      once: true,
    })
  }

  return promise
}

export const waitForGuideTourScrollSettle = (): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve()
  }

  if (isGuideTourPageScrollLocked()) {
    return settleAfterLockedPageScroll()
  }

  return settleAfterWindowScroll()
}
